import { useState } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';

import { GetEffectiveClientCashPercentage, RootState, getSelectedCurrency } from '@share/utils';
import { GetWalletAmount, IsCapitalVacationsAccount } from '@share/utils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { WalletDetailsModal } from '../../common/wallet-details-modal';

import './style.scss';

export function HeaderWalletMessage() {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  const loginStore = useSelector((state: RootState) => state.loginStore);

  const { account, user, userWallet, userWalletData } = loginStore;

  const hasClientCash = account?.hasClientCash;
  const isLoggedAshevillePlay = account?.isAshevillePlay && !user?.isAshevillePlayAdmin;
  const isLogged = !!userWallet || isLoggedAshevillePlay;

  if (!hasClientCash || !isLogged) {
    return null;
  }

  const clientCashName = isEmpty(account?.walletClientCashName)
    ? 'Client Cash'
    : account?.walletClientCashName;

  const currency = !isEmpty(userWalletData?.label)
    ? userWalletData?.label
    : getSelectedCurrency(account);

  const isCapital = IsCapitalVacationsAccount(account);

  // With no earning percentage configured (account-level or per-profile override) nothing can
  // ever accrue, so the pending bucket is meaningless — hide it instead of showing a balance the
  // member has no way to grow.
  const showPending =
    !account?.walletIsExternal && GetEffectiveClientCashPercentage(loginStore) > 0;

  return (
    <div className="header-wallet-message">
      <div className="header-wallet-message__card">
        <div className="header-wallet-message__active">
          <p className="header-wallet-message__title">
            <FontAwesomeIcon className="header-wallet-message__title-icon" icon={faWallet} />
            <FormattedMessage
              id={isCapital ? 'wallet.header.title.points' : 'wallet.header.title'}
              values={{ clientCash: clientCashName }}
            />
          </p>

          <p className="header-wallet-message__amount">
            {GetWalletAmount(userWalletData?.balance, account, userWalletData, clientCashName)}
          </p>

          <p className="header-wallet-message__hint">
            <FormattedMessage id="wallet.header.available_now" />
          </p>
        </div>

        {showPending ? (
          <div className="header-wallet-message__pending">
            <p className="header-wallet-message__pending-row">
              <span className="header-wallet-message__pending-label">
                <FormattedMessage id="wallet.menu.pending_cash" values={{ clientCash: clientCashName }} />
              </span>
              <span className="header-wallet-message__pending-value">
                {GetWalletAmount(userWalletData?.pendingBalance, account, userWalletData)}
              </span>
            </p>

            <p className="header-wallet-message__hint">
              <FormattedMessage id="wallet.header.pending_release" />
            </p>
          </div>) : null}

        <button
          type="button"
          className="header-wallet-message__details"
          onClick={() => setIsDetailsOpen(true)}
        >
          <FormattedMessage id={isCapital ? 'wallet.header.view_details.points' : 'wallet.header.view_details'} />
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>

      <WalletDetailsModal
        isOpen={isDetailsOpen}
        clientCashName={clientCashName}
        currency={currency}
        onClose={() => setIsDetailsOpen(false)}
      />
    </div>
  );
}
